// extracted by mini-css-extract-plugin
export var fileUpload = "_en-1";
export var modalButton = "_en-0";